import React, { useContext } from "react";
import { DocumentIcon, DownloadIcon } from "@heroicons/react/outline";
import formatFileSize from "lib/formatFileSize";
import { DialogContext } from "contexts/DialogContext";
import { ACTIONS } from "reducers/dialogReducer";
import DocumentRequest from "components/DocumentRequest";
import Body from "components/Body";

export default function ParagraphFile({ data }) {
  const { dispatch } = useContext(DialogContext);
  const isPrivate = Object.prototype.hasOwnProperty.call(
    data,
    "field_private_file"
  );
  const file = isPrivate ? data.field_private_file : data.field_file;
  const splitted = file.filename.split(".");
  const extension = splitted.pop();
  const name = file.resourceIdObjMeta.description || splitted.join(".");
  const filesize = formatFileSize(file.filesize);

  const handleClick = () => {
    if (isPrivate) {
      dispatch({
        type: ACTIONS.OPEN,
        payload: {
          title: "Demande de documentation",
          body: <DocumentRequest file={file} />,
        },
      });
    } else if (typeof window !== "undefined") {
      window.location.assign(
        `/api/file/download?filename=${encodeURIComponent(
          file.filename
        )}&uri=${encodeURIComponent(file.uri.value)}`
      );
    }
  };

  return (
    <div
      className="group h-full p-8 bg-primary text-white shadow-spread rounded-lg overflow-hidden cursor-pointer hover:bg-primary-dark transition-colors"
      onClick={handleClick}
    >
      <div className="flex items-center">
        <div className="flex-1">
          <DocumentIcon className="h-6 w-6 mb-1" />
          <div className="font-important text-xl font-medium mb-1 capitalize">
            <span className="">{data.field_title || name}</span>
          </div>

          <div className="flex items-center gap-2 uppercase">
            <span>{extension}</span>
            <span>-</span>
            <span>{filesize}</span>
          </div>
        </div>
        <div>
          <a
            href={`${process.env.NEXT_PUBLIC_DRUPAL_RUNTIME_BASE_URL}${file.uri.url}`}
            className="block p-2 bg-white rounded-full"
            title={`Ouvrir "${file.filename}" dans un nouvel onglet`}
            target="blank"
          >
            <DownloadIcon className="h-5 w-5 text-primary" aria-hidden="true" />
            <span className="sr-only">Voir</span>
          </a>
        </div>
      </div>
      {data.field_text && (
        <div className="prose prose-white font-medium text-sm mt-2">
          <Body value={data.field_text.processed} />
        </div>
      )}
    </div>
  );
}
